import React from "react";
import * as OBC from "@thatopen/components";
import * as OBF from "@thatopen/components-front";
import { ILoader, ITool, Viewer } from "@treegram/viewer-core";
import { ViewerLoadingProgress } from "@/hooks/viewer/use-viewer";

export type ViewerWorld = OBC.SimpleWorld<
    OBC.SimpleScene,
    OBC.OrthoPerspectiveCamera,
    OBF.PostproductionRenderer
>;

export interface ViewerContextProps {
    setContainer: (container: HTMLDivElement | null) => void;
    
    viewer: Viewer | undefined;
    world: ViewerWorld | undefined;
    isLoading: boolean;
    loadingProgress: ViewerLoadingProgress;
    error: Error | undefined;
    retry: () => void;

    getTool: <T extends ITool>(toolClass: new (...args: never[]) => T) => T | undefined;
    getToolByKeyName: <T extends ITool = ITool>(keyName: string) => T | undefined;

    getLoader: <T extends ILoader>(loaderClass: new (...args: never[]) => T) => T | undefined;
    getLoaders: <T extends ILoader>(loaderClass: new (...args: never[]) => T) => T[];
    getLoaderByKeyName: <T extends ILoader = ILoader>(keyName: string) => T | undefined;
    getLoadersByKeyName: <T extends ILoader = ILoader>(keyName: string) => T[];
}

export const ViewerContext = React.createContext<ViewerContextProps | undefined>(undefined);
